import { motion } from 'framer-motion'
import { FunctionComponent } from 'react'
import { Icon } from 'utils'

interface RemoveButtonInterface {
  id: string
  type?: 'menu' | 'plumbing_plan'
  handleRemove: ({
    id,
    type
  }: {
    id: string
    type?: 'menu' | 'plumbing_plan'
  }) => void
  isDisabled: boolean
}

const RemoveButton: FunctionComponent<RemoveButtonInterface> = ({
  id,
  type,
  handleRemove,
  isDisabled
}) => {
  return (
    <motion.button
      type="button"
      data-testid="remove"
      className="cursor-pointer"
      whileHover={{ scale: 1.8 }}
      onClick={() => {
        !type && !isDisabled && handleRemove({ id })
        type && !isDisabled && handleRemove({ id, type })
      }}
    >
      <div className="wc-hidden--visually">Remove</div>
      <Icon
        className="btn-tertiary"
        role="presentation"
        id="#bin"
        width="19.35"
        height="22"
        fill={!isDisabled ? '#006ba6' : '#c7c7c7'}
      />
    </motion.button>
  )
}

export default RemoveButton
